import { StarFilledIcon } from "@radix-ui/react-icons";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "../../../src/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import { HandHeart, X } from "lucide-react";
import React from "react";

export default function TopBar() {
  return (
    <div className={"w-full relative overflow-hidden"}>
      <Carousel
        className="text-center border-b border-neutral-700 bg-neutral-800 text-neutral-100 font-light flex justify-center items-center py-1"
        opts={{
          align: "start",
          loop: true,
        }}
        plugins={[
          Autoplay({
            delay: 4000,
            stopOnInteraction: false,
          }),
        ]}
      >
        <CarouselContent className="flex-nowrap whitespace-nowrap text-[12px]">
          <CarouselItem className="basis-full flex gap-2 justify-center items-center">
            <HandHeart className="stroke-1 size-4" />
            <span>
              10% Off Your First Order! PromoCode:
              <span className="font-bold"> MAGIC-10</span>
            </span>
          </CarouselItem>
        </CarouselContent>
      </Carousel>
    </div>
  );
}
